/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

import type { ImageFields } from '@/service/fragments/imageFieldsFrag'
import type { Maybe } from 'graphql/jsutils/Maybe'
import { maxBy, minBy } from '@/util/array'

export const ImageType = {
    BACKGROUND: 'BACKGROUND',
    PROFILE: 'PROFILE',
} as const

export function imagesOfType(
    images: Maybe<readonly Maybe<ImageFields>[]>,
    type: string
): readonly ImageFields[] {
    if (!images) return []
    return images.filter((image): image is ImageFields => {
        return image?.imageType === type
    })
}

export function getSmallestImage(
    images: Maybe<readonly Maybe<ImageFields>[]>,
    type?: string
): ImageFields | null {
    if (!images) return null
    if (type) images = imagesOfType(images, type)
    return minBy(images, (image) => image?.width ?? Number.MAX_VALUE) ?? null
}

export function getLargestImage(
    images: Maybe<readonly Maybe<ImageFields>[]>,
    type?: string
): ImageFields | null {
    if (!images) return null
    if (type) images = imagesOfType(images, type)
    return maxBy(images, (image) => image?.width ?? 0) ?? null
}
